// Shared UI helpers for donor funding-request pages (Wave 3C).
// Presentation only — no business writes; no mock data.

export const FUNDING_STATUS_LABEL = {
  DRAFT: "مسودة",
  SUBMITTED: "مُرسَل",
  UNDER_REVIEW: "قيد المراجعة",
  INFORMATION_REQUIRED: "بحاجة معلومات إضافية",
  PLAN_IN_PREPARATION: "خطة قيد الإعداد",
  PLAN_READY: "الخطة جاهزة",
  PLAN_PUBLISHED: "الخطة منشورة",
  REVISION_REQUESTED: "طُلبت مراجعة الخطة",
  CONTRACTING: "قيد التعاقد",
  DECLINED: "مرفوض",
  WITHDRAWN: "مسحوب",
};

export const FUNDING_STATUS_TONE = {
  DRAFT: "bg-slate-100 text-slate-700 border-slate-200",
  SUBMITTED: "bg-sky-50 text-sky-800 border-sky-200",
  UNDER_REVIEW: "bg-sky-50 text-sky-800 border-sky-200",
  INFORMATION_REQUIRED: "bg-amber-50 text-amber-800 border-amber-200",
  PLAN_IN_PREPARATION: "bg-indigo-50 text-indigo-800 border-indigo-200",
  PLAN_READY: "bg-indigo-50 text-indigo-800 border-indigo-200",
  PLAN_PUBLISHED: "bg-emerald-50 text-emerald-800 border-emerald-200",
  REVISION_REQUESTED: "bg-amber-50 text-amber-800 border-amber-200",
  CONTRACTING: "bg-teal-50 text-teal-800 border-teal-200",
  DECLINED: "bg-rose-50 text-rose-800 border-rose-200",
  WITHDRAWN: "bg-slate-100 text-slate-600 border-slate-200",
};

export const FUNDING_EVENT_LABEL = {
  REQUEST_CREATED: "أُنشئت المسودة",
  REQUEST_SUBMITTED: "تم إرسال الطلب",
  REVIEW_STARTED: "بدأت المراجعة",
  INFORMATION_REQUESTED: "طُلبت معلومات إضافية",
  INFORMATION_PROVIDED: "قُدِّمت المعلومات المطلوبة",
  PLAN_PREPARATION_STARTED: "بدأ إعداد الخطة",
  PLAN_READY: "الخطة جاهزة",
  PLAN_RETURNED_TO_AUTHOR: "أُعيدت الخطة إلى المُعِد",
  PLAN_PUBLISHED: "نُشرت الخطة",
  PLAN_ACCEPTED: "تم اعتماد الخطة",
  REVISION_REQUESTED: "طُلبت مراجعة الخطة",
  REQUEST_DECLINED: "رُفض الطلب",
  REQUEST_WITHDRAWN: "سُحب الطلب",
  PLAN_DRAFT_CREATED: "أُنشئت مسودة الخطة",
  PLAN_APPROVED: "اعتُمدت الخطة",
  ADMIN_INTERNAL_NOTE: "ملاحظة إدارية",
};

export function formatSAR(v) {
  if (v == null || v === "") return "—";
  const num = Number(v);
  if (!Number.isFinite(num)) return String(v);
  return num.toLocaleString("ar-EG", { maximumFractionDigits: 2 }) + " ر.س";
}

export function formatArabicDateTime(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("ar-EG", {
      year: "numeric", month: "short", day: "numeric",
      hour: "2-digit", minute: "2-digit",
    });
  } catch {
    return String(iso);
  }
}
